module.exports = __webpack_public_path__ + "img/TrensBioScience-497x500.17209bfc.png";